// src/components/ChatBot/StreamTabs.js
import React from 'react';
import { useChat } from './ChatContext';

const StreamTabs = () => {
  const { activeStream, setActiveStream } = useChat();

  return (
    <div className="stream-tabs-container">
      <button
        className={`stream-tab ${activeStream === 'chat' ? 'stream-tab-active' : 'stream-tab-inactive'}`}
        onClick={() => setActiveStream('chat')}
        aria-pressed={activeStream === 'chat'}
      >
        Chat
      </button>
      <button
        className={`stream-tab ${activeStream === 'tutor' ? 'stream-tab-active' : 'stream-tab-inactive'}`}
        onClick={() => setActiveStream('tutor')}
        aria-pressed={activeStream === 'tutor'}
      >
        Tutor
      </button>
    </div>
  );
};

export default StreamTabs;